import React from 'react';
import PropTypes from 'prop-types';
/*
  This component displays a div with a background image

  Usage: <BackgroundImage src={source} {...other attributes}>
        {...child components}
       </BackgroundImage>
*/
export default class BackgroundImage extends React.Component {
  static get propTypes () {
    return {
      src: PropTypes.string.isRequired,
      className: PropTypes.string,
      style: PropTypes.object,
      children: PropTypes.node,
    };
  }

  static get defaultProps () {
    return {
      className: '',
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      error: false,
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentDidMount() {
    // Making this a global so it can be later
    // nullified when the component unmounts
    this.image = new Image();

    this.image.src = this.props.src;
    this.image.onload = this.handleLoad;
    this.image.onerror = this.handleError;
  }

  shouldComponentUpdate(nextState, nextProps) {
    return !this.state.loaded;
  }

  componentWillUnmount() {
    this.image.onerror = null;
    this.image.onload = null;
    this.image = null;
  }

  handleLoad(e) {
    this.setState({
      loaded: true,
    });
  }

  handleError(e) {
    console.error('Failed to load ', this.props.src);

    this.setState({
      error: true,
    });
  }

  render() {
    const {src, children, className, ...props} = this.props;
    const currentClass = !this.state.loaded || this.state.error ? `${className} background-image` : `${className} background-image bg-loaded`;
    // const source = !this.state.loaded || this.state.error ? placeholder : src;

    return (
      <div style={{backgroundImage: `url(${src})`}} className={currentClass} {...props}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/BackgroundImage.js